import { createSlice } from '@reduxjs/toolkit';
import type {
  WeibullRow,
  WeibullWorkOrders,
} from 'views/SurvivalAnalysis/Survivability/types';

export interface OverviewState {
  data: WeibullRow[];
  workOrders: WeibullWorkOrders[];
  isLoadingSurvivability: boolean;
}

const initialState: OverviewState = {
  data: [],
  workOrders: [],
  isLoadingSurvivability: false,
};

export const survivabilitySlice = createSlice({
  name: 'survivabilitySlice',
  initialState,
  reducers: {
    appendData(state, { payload }) {
      state.data = payload.weibullData;
      state.workOrders = payload.workOrders;
    },
    setIsLoadingSurvivability(state, { payload }) {
      state.isLoadingSurvivability = payload;
    },
  },
});

export const { appendData, setIsLoadingSurvivability } =
  survivabilitySlice.actions;

export const SurvivabilitySlice = createSlice({
  name: 'survivabilitySlice',
  initialState,
  reducers: {},
});

export default survivabilitySlice.reducer;
